module.exports = __webpack_public_path__ + "static/media/exposeBottomRail.09124928.png";